import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import { fontSize, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Link } from './ui';

const StyledContainedImage = styled.section`
  ${({ isBlogDetail, isCaseStudyDetail, isSalesforceExplainerDetail }) => {
    if (!isBlogDetail && !isCaseStudyDetail && !isSalesforceExplainerDetail) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        padding-left: 0;
        padding-right: 0;
      `;
    }
  }};
`;

const StyledInner = styled.figure`
  margin: 0 auto;

  ${({ maxWidth }) => {
    if (maxWidth) {
      return css`
        max-width: ${maxWidth}px;
      `;
    }
  }}
`;

const StyledCaption = styled.figcaption`
  margin-top: 6px;
  font-style: italic;
  ${fontSize(11)};
  text-align: center;

  ${minBreakpointQuery.small`
    margin-top: 8px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 10px;
  `}
`;

const ContainedImage = ({
  image,
  maxWidth,
  caption,
  link,
  isBlogDetail,
  isCaseStudyDetail,
  isSalesforceExplainerDetail,
}) => (
  <StyledContainedImage
    isBlogDetail={isBlogDetail}
    isCaseStudyDetail={isCaseStudyDetail}
    isSalesforceExplainerDetail={isSalesforceExplainerDetail}
  >
    <StyledContainer
      narrower={isBlogDetail || isSalesforceExplainerDetail}
      narrow={isCaseStudyDetail}
      isBlogDetail={isBlogDetail}
    >
      <StyledInner maxWidth={maxWidth}>
        {link ? (
          <Link to={link.pageUrl}>
            <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />
          </Link>
        ) : (
          <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />
        )}
        {caption && <StyledCaption>{caption}</StyledCaption>}
      </StyledInner>
    </StyledContainer>
  </StyledContainedImage>
);

export default ContainedImage;
